import React from 'react'
import { EmptyContent } from '@ztechapps/webui.util'
import { SeeOurProductsButton } from '../../components/SeeOurProductsButton'

export const OrderItemsEmptyContent = () => {
  return (
    <EmptyContent
      icon="box"
      message="Your order items are being prepared"
      subMessage="We're still preparing the items for this order. In the meantime, feel free to browse our products."
      action={<SeeOurProductsButton />}
    />
  )
}
